import Vue from 'vue';
export default new Vue({
    data: {
        username: '',
        smallAppName: '',
        type: '',
        mid: '',
        code: 0
    }
});


// WEBPACK FOOTER //
// ./src/lib/bus.js